import { render } from "./Resources.vue?vue&type=template&id=5ae2a25c"
const script = {}

import exportComponent from "C:\\Users\\ydcoo\\OneDrive\\Desktop\\GitHub\\SFA-Website\\SFA-Web\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__